import { createFormConfigRegistry } from '@risksmart-app/shared/forms/formConfigRegistry';
import { useMemo } from 'react';
import { useModulesStore } from 'src/context/moduleContext';
import { useIsFeatureFlagEnabled } from 'src/hooks/useIsFeatureFlagEnabled';

/**
 * Returns the whole form config registry
 * @returns
 */
export const useFormConfigRegistry = () => {
  const formSectionsEnabled = useIsFeatureFlagEnabled('dynamic_forms');
  const modules = useModulesStore((s) => s.modules);

  return useMemo(
    () => createFormConfigRegistry(formSectionsEnabled, modules),
    [formSectionsEnabled, modules]
  );
};
